<template>
    <div>
        <label v-html="label"></label>
        <VueSignaturePad
          width="400px"
          height="200px"
          ref="signaturePad"
        />
    </div>
</template>
<script>
  export default {
    name: 'SignPad',
    props: {
      label: String,
      name: String,
    },
    mounted () {
      this.$refs.signaturePad.clearSignature();
    },
    destroyed () {
      this.$refs.signaturePad && this.$refs.signaturePad.lockSignaturePad();
    },
    methods: {
      clear() {
        this.$refs.signaturePad.clearSignature();
      },
      async files() {
        const signature = this.$refs.signaturePad.saveSignature();
        return [{
          name: this.name,
          type: 'image/png',
          data: await (await fetch(signature.data)).blob(),
        }]
      }
    }
  }
</script>
<style scoped>
    div {
        margin: 16px;
        background: white;
        border: 1px solid #666;
        position: relative;
        
    }
    label {
        position: absolute;
        pointer-events: none;
        bottom: -2px;
        left: 5px;
        color: black;
    }
</style>
